import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import featureImg3 from '../Images/land-finding-img3.png';
function SupplierTypeSection() {
  return (
    <div className={css.supplierSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <h3>
              <FormattedMessage id="OffsiteSuppliersPage.SupplierTypeSection.timberTitle" />
            </h3>
            <p>
              <FormattedMessage id="OffsiteSuppliersPage.SupplierTypeSection.timberDescription" />
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" />
            </div>
            <h3>
              <FormattedMessage id="OffsiteSuppliersPage.SupplierTypeSection.steelTitle" />
            </h3>
            <p>
              <FormattedMessage id="OffsiteSuppliersPage.SupplierTypeSection.steelDescription" />
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg3} alt="" />
            </div>
            <h3>
              <FormattedMessage id="OffsiteSuppliersPage.SupplierTypeSection.sipTitle" />
            </h3>
            <p>
              <FormattedMessage id="OffsiteSuppliersPage.SupplierTypeSection.sipDescription" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierTypeSection;
